// extracted by mini-css-extract-plugin
export default {"googleLoginBadge":"GoogleLoginBadge_googleLoginBadge__E5azl"};